var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"douKuaiCell"},[_c('div',[_c('div',[_c('span',[_vm._v(_vm._s(_vm._f("formatPlatformName")(_vm.row['platform_id'],'unify'))+"：")]),_c('span',[_vm._v(_vm._s(_vm.row['anchor_account']))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }